import {OcrPage, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import OrientationEnum from "./OrientationEnum";
import FormatEnum from "./FormatEnum";

export class PortalOcrPage extends OcrPage implements Parameter {
	public format?: string;
	public orientation?: OrientationEnum;

	constructor(data: any) {
		super(data);

		this.format = FunctionHelper.exists(data?.format) ? data.format : FormatEnum.ORIGINAL;
		this.orientation = FunctionHelper.exists(data?.orientation) ? data.orientation : OrientationEnum.VERTICAL;
	}

	public static getFormatDefault(): string {
		return FormatEnum.ORIGINAL;
	}

	public static getOrientationDefault(): OrientationEnum {
		return OrientationEnum.VERTICAL;
	}

	public static fromJson(data: any): PortalOcrPage {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalOcrPage(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'format': this.format,
			'orientation': this.orientation
		};
	}

	public clone(): PortalOcrPage {
		return PortalOcrPage.fromJson(this.toJson());
	}
}